import { createWebHistory, createRouter } from "vue-router";
import HomePage from "@/views/HomePage.vue";

const Contact = () => import('../components/portfolio/Contact.vue');

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomePage,
  },
  {
    path: '/contact',
    name: 'contact',
    component: Contact
  }
  // ! the '*' must be the last path for error handling
  // {
  //   path: '*',
  //   name: 'notFound',
  //   component: NotFound,
  // },
];


const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
